import { render } from "./Psihology.vue?vue&type=template&id=36d9e560&ts=true"
import script from "./Psihology.vue?vue&type=script&lang=ts"
export * from "./Psihology.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__